<template>
    <section class="project-step project-step3-container mgt-3 mgb-3">
        <div class="container-fluid">
            <div class="custom-container">
                <div class="section-heading">
                    <i class="fad fa-layer-plus"></i>
                    <h1 class="m-color">
                        Adauga proiect nou
                    </h1>
                </div>
                <form id="form-step-3" class="step-form general-form">
                    <div class="secondary-heading">
                        <div class="secondary-heading-icon">
                            <i class="fad fa-building"></i>
                        </div>
                        <span> Adauga Case </span>
                    </div>
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                            <p class="custom-input-error" id="general_error"></p>
                        </div>
                        <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                            <div class="blocks-tabs-content tab-content">
                                <div class="levels-container">
                                    <div class="single-level-row" v-for="(itemRow, indexItem) in houses" :key="indexItem">
                                <div class="row">
                                    <div class="col-xl-1 col-lg-1 col-md-6 col-sm-12">
                                        <div class="level-item-nr level-strip-cell">
                                            <p class="level-cell-heading"> Nr.Crt. </p>
                                            <p class=""> {{indexItem+1}}</p>
                                            <input type="hidden" name="nr_crt" :value="indexItem+1" />
                                        </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                        <div class="level-item-nr level-strip-cell">
                                            <p class="level-cell-heading"> Numar Casa </p>
                                            <div class="input-container">
                                                <div class="input-group">
                                                    <input type="text" v-model="itemRow.houseNumber">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                        <div class="level-strip-cell">
                                            <p class="level-cell-heading"> Model </p>
                                            <p class=""> {{ model.rooms_count ? model.rooms_count.name : '' }} tip {{model.model_type}} </p>
                                        </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                        <div class="level-item-size level-strip-cell">
                                            <p class="level-cell-heading"> Suprafata totala(m²) </p>
                                            <div class="input-container">
                                                <div class="input-group mg-b">
                                                    <input type="number" v-model="itemRow.usefulSurface">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="level-item-size level-strip-cell">
                                            <p class="level-cell-heading"> Suprafata balcon(m²) </p>
                                            <div class="input-container">
                                                <div class="input-group mg-b">
                                                    <input type="number" v-model="itemRow.terraceSurface">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="level-item-size level-strip-cell">
                                            <p class="level-cell-heading"> Suprafata teren(m²) </p>
                                            <div class="input-container">
                                                <div class="input-group mg-b">
                                                    <input type="number" v-model="itemRow.gardenSurface">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                        <div class="level-item-size level-strip-cell">
                                            <p class="level-cell-heading"> * Pret </p>
                                            <div class="input-container">
                                                <div class="input-group mg-b">
                                                    <input type="number" v-model="itemRow.price">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                        <div class="level-item-size level-strip-cell">
                                            <p class="level-cell-heading"> Pret cu credit </p>
                                            <div class="input-container">
                                                <div class="input-group mg-b">
                                                    <input type="number" v-model="itemRow.credit_price">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                        <div class="level-item-size level-strip-cell">
                                            <p class="level-cell-heading"> * Status </p>
                                            <div class="input-container">
                                                <div class="input-group mg-b">
                                                    <select name="rooms" v-model="itemRow.status">
                                                        <option value="available"> Disponibil</option>
                                                        <option value="reserved"> Rezervat</option>
                                                        <option value="sold"> Vandut</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                        <div class="level-item-size level-strip-cell">
                                            <p class="level-cell-heading"> Data Finalizare  </p>
                                            <div class="input-container">
                                                <div class="input-group mg-b">
                                                    <input type="text" v-model="itemRow.finalizedAt">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="single-level-row-availability">
                                    <div class="general-check step-check">
                                        <input type="checkbox" v-model="itemRow.showStatusForClients" id="clients_availability" class="custom-checkbox">
                                        <label for="clients_availability" class="custom-checkbox-label">
                                            <span></span>
                                            <p>
                                                Vizibil pentru clienti
                                            </p>
                                        </label>
                                    </div>
<!--                                    <div class="general-check step-check">-->
<!--                                        <input type="checkbox" v-model="itemRow.showStatusForAgencies" id="agents_availability" class="custom-checkbox">-->
<!--                                        <label for="agents_availability" class="custom-checkbox-label">-->
<!--                                            <span></span>-->
<!--                                            <p>-->
<!--                                                Vizibil pentru agenti-->
<!--                                            </p>-->
<!--                                        </label>-->
<!--                                    </div>-->
                                </div>
                                <div class="add-field-btn" v-if="indexItem === 0"
                                     @click="addItemRow()">
                                    <i class="fad fa-plus-circle"></i>
                                </div>
                                <div class="remove-field-btn" v-if="indexItem > 0">
                                    <i class="fad fa-minus-circle"
                                       v-on:click="removeItemRow(indexItem)"></i>
                                </div>
                            </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                            <div class="center-content mt-3 save-btn">
                                <button type="submit" class="general-btn positive-btn">
                                    <i class="fad fa-save"></i>
                                    <span> Salveaza </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </section>
</template>

<script>

  export default {
    name: "AddProjectStep3House",
    props: ['project', 'model'],
    data() {
      return {
        houses: [],
        counter: 0
      }
    },
    async mounted() {
      let vm = this;
      $('#form-step-3').submit(function (e) {
        e.preventDefault();
        vm.save();
      })
      this.houses.push({
        nrCrt: 1,
        houseNumber: '',
        usefulSurface: vm.model.useful_surface,
        terraceSurface: vm.model.terrace_surface,
        gardenSurface: vm.model.garden_surface,
        price: vm.model.price,
        credit_price: vm.model.credit_price,
        status: 'available',
        showStatusForClients: true,
        showStatusForAgencies: false,
        finalizedAt: ''
      });
    },
    methods: {
      increaseCounter(indexBuilding, indexLevel, indexItem) {
        let counter = 1;
        for(let i=0; i<indexLevel; i++) {
          counter += this.selected[indexBuilding].selectedLevels[i].itemRows.length;
        }
        this.selected[indexBuilding].selectedLevels[indexLevel].itemRows[indexItem].nrCrt = counter+indexItem;
        return counter+indexItem;
      },
      addItemRow: function () {
        this.houses.push({
          nrCrt: this.houses.length+1,
          houseNumber: '',
          usefulSurface: this.model.useful_surface,
          terraceSurface: this.model.terrace_surface,
          gardenSurface: this.model.garden_surface,
          price: this.model.price,
          credit_price: this.model.credit_price,
          status: 'available',
          showStatusForClients: true,
          showStatusForAgencies: true,
          finalizedAt: ''
        });
      },
      removeItemRow: function (index) {
        this.houses.splice(index, 1);
      },
      save() {
        let vm = this
        window.axios.post(`/developer/${this.project.id}/${this.model.id}/add-project-step3-house`,this.houses)
          .then(function () {
            window.Swal.fire({
              html: 'Casele au fost adaugate cu succes',
              icon: 'success',
              timer: 2000,
              showCancelButton: false,
              showConfirmButton: false
            }).then(() => {
              window.location.href = `/developer/project/${vm.project.id}?tab=house`
            })
          })
          .catch(function (err) {
            window.showError(err)
          });
      }
    }
  }
</script>
